import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import {
  updateStorePickupCounter,
  updateStorePickupTiming,
} from "../../../../helper";
import ToggleButton from "../../../../components/ToggleButton/index";
import { getCategoriesView } from "../../../../components/helper";

export default function StorePickup(props) {
  const {
    storePickupCounter,
    storePickupSlots,
    fetchStorePickupCounter,
  } = props;

  const getStorePickupView = (
    storePickupSlots,
    startIndex,
    endIndex,
    handleOnClick
  ) => {
    let retval = [];
    for (let i = startIndex; i <= endIndex; i++) {
      retval.push(
        <>
          <p className="text-center">
            {storePickupSlots[i].store_pickup_timings}
          </p>
          <ToggleButton
            secondLabel="Enabled"
            firstLabel="Disabled"
            checkedValue={storePickupSlots[i].status}
            handleOnChange={async () =>
              updateStorePickupTiming(
                storePickupSlots[i].store_pickup_timings,
                !storePickupSlots[i].status
              ).then(() => fetchStorePickupCounter())
            }
          />
        </>
      );
    }
    return retval;
  };

  const [counter, setCounter] = useState(storePickupCounter);
  return (
    <div>
      <div className="d-flex w-50 mx-auto justify-content-center mt-3 align-items-center">
        <Form.Group className="w-50">
          <Form.Control
            type="number"
            value={counter}
            onChange={(event) =>
              setCounter(event.target.value >= 0 ? event.target.value : null)
            }
          />
        </Form.Group>
        <span className="ml-2 mr-2">No Of Days</span>
        <Button
          onClick={() =>
            Number(counter) >= 0
              ? updateStorePickupCounter(counter)
              : alert("Invalid counter value")
          }
        >
          Update
        </Button>
      </div>
      {storePickupSlots &&
        getCategoriesView(storePickupSlots, getStorePickupView, () => {}, {
          xs: 1,
          sm: 1,
          md: 4,
          lg: 4,
        })}
    </div>
  );
}
